<script setup lang="ts">
defineProps<{
  state: { canGenerate: boolean; label: string; costLabel: string; busy: boolean };
}>();
const emit = defineEmits<{ (e: 'generate'): void }>();
const { t } = useI18n();
</script>

<template>
  <div class="bridge-gen">
    <button
      class="bridge-cta"
      :disabled="!state.canGenerate"
      @click="emit('generate')"
    >
      <span class="spark">✦</span>
      <span class="flex-1 text-left">{{ state.label || t('editor.generate') }}</span>
      <span v-if="state.costLabel" class="cost">{{ state.costLabel }}</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
/* 桥接生成按钮：移动端常驻页面底部，桌面在所属列下方正常排布 */
.bridge-gen {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom));
  background: rgba(10, 10, 10, 0.9);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.bridge-cta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  border-radius: 9999px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #f97316 0%, #ea580c 50%, #c2410c 100%);
  box-shadow: 0 8px 24px -8px rgba(249, 115, 22, 0.5);
  transition: all 0.2s;
}
.bridge-cta:disabled { opacity: 0.4; cursor: not-allowed; }
.bridge-cta .spark { color: #fde68a; }
.bridge-cta .cost {
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.3);
  padding: 0.125rem 0.75rem;
  font-size: 0.75rem;
}
@media (min-width: 768px) {
  .bridge-gen {
    position: static;
    z-index: auto;
    padding: 0;
    margin-top: 1rem;
    background: transparent;
    backdrop-filter: none;
    border-top: 0;
  }
}
</style>
